import type { Meta, StoryObj } from '@storybook/react'

import VendorIntegrationPage from './VendorIntegrationPage';
import Box from '@mui/material/Box';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';

const Template = (args) => {
  return (
    <Box sx={{ minHeight: "2000px" }}>
      <QueryParamProvider adapter={ReactRouter6Adapter}>
        <VendorIntegrationPage {...args} />
      </QueryParamProvider>
    </Box>
  )
};

const meta : Meta<typeof Template> = {
  title: "Pages/VendorIntegrationPage",
  component: Template,
};

type Story = StoryObj<typeof Template>;

export default meta

export const Default : Story = {
  render: Template,
  parameters: {
    reactRouter: {
      routePath: "/contracts/:contractId/*",
      routeParams: { contractId: "88" },
      browserPath: "/contracts/88/integrations",
    },
    orbit: {
      records: [
        {
          "id": "88",
          "type": "contracts",
          "attributes": {
            "vendor-code": "adhere",
            "payout": "cost_per_lead",
            "can-post-leads": true
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "vendor": {
              "data": {
                "id": "18",
                "type": "vendors"
              }
            },
          }
        },
        {
          "id": "197",
          "type": "clients",
          "attributes": {
            "name": "CareerStep",
            "created-at": "2022-08-31T17:26:25.152Z",
            "updated-at": "2025-02-06T07:23:18.588Z",
            "secondary-color": null,
            "primary-color": null,
            "tcpa-disclosure": "",
            "internal-name": null,
            "lp-email-sender": null,
            "lp-area-codes": null,
            "lp-continue-url": null,
            "implicit-tcpa": false,
            "google-conversion-id": null,
            "complyed-client-id": null,
            "campus-explorer-college-id": null,
            "num-programs": 93,
            "aor": false,
            "contact-name": null,
            "contact-email": null,
            "contact-address": null,
            "contact-city": null,
            "contact-state": null,
            "contact-zip": null,
            "contact-phone": null,
            "time-zone": "America/Denver",
            "notes": null,
            "ingestion-endpoint": 1,
            "metadata": {
              "statuses": [
                {
                  "key": "pending",
                  "value": "Pending"
                },
                {
                  "key": "filtered",
                  "value": "Filtered"
                },
                {
                  "key": "rejected",
                  "value": "Rejected"
                },
                {
                  "key": "error",
                  "value": "Error"
                },
                {
                  "key": "returned",
                  "value": "Returned"
                },
                {
                  "key": "new_lead",
                  "value": "New"
                },
                {
                  "key": "interviewed",
                  "value": "Qualified"
                },
                {
                  "key": "enrolled",
                  "value": "Enrolled"
                },
                {
                  "key": "custom_good_1",
                  "value": "Remarketing"
                },
                {
                  "key": "custom_good_2",
                  "value": "Not Interested"
                },
                {
                  "key": "custom_good_3",
                  "value": "Not Qualified"
                },
                {
                  "key": "custom_good_4",
                  "value": "Refunded"
                }
              ],
              "cpe-billable-delay-in-days": 15
            },
            "limits-updated-at": "2025-02-06T07:23:18.569Z",
            "response-time": "five_minutes",
            "filtered-leads-client": false,
            "agency-id": null,
            "vanity-leads-hostname": null,
            "vanity-leads-path": "/careerstep/leads",
            "leads-endpoint-id": 1,
            "show-degree-program-changes": false,
            "logo": null,
            "compliance-logo": null,
            "brand-guidelines-document": null,
            "brand-guidelines-document-filename": null
          },
          "relationships": {
            "leads-endpoint": {
              "data": {
                "id": "1",
                "type": "endpoints"
              }
            },
            "exclusion-rules": {
              "data": [
                { "type": "exclusion-rules", "id": "9901" },
                { "type": "exclusion-rules", "id": "9900" },
                { "type": "exclusion-rules", "id": "9891" },
                { "type": "exclusion-rules", "id": "1470" },
                { "type": "exclusion-rules", "id": "1488" },
                { "type": "exclusion-rules", "id": "1487" },
              ],
            },
          }
        },
        {
          "id": "18",
          "type": "vendors",
          "attributes": {
            "name": "Leads R Us",
          },
        },
        {
          "id": "1",
          "type": "endpoints",
          "attributes": {
            "hostname": null,
            "path": "/careerstep/leads",
            "parameter-names": {
              "source": "trafficSource",
              "campaign_id": "campaignID",
              "program_code": "programInterest"
            }
          }
        },
        {
          "id": "58",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "last_name",
            "name": "lastName",
            "description": "Last Name",
            "required": true,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.218Z",
            "updated-at": "2022-08-31T17:26:25.218Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "60",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "city",
            "name": "contactCity",
            "description": "Contact City",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.237Z",
            "updated-at": "2022-08-31T17:26:25.237Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "62",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "zip_code",
            "name": "contactPostalCode",
            "description": "Contact Postal Code",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.267Z",
            "updated-at": "2022-08-31T17:26:25.267Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "63",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "email",
            "name": "email",
            "description": "Email",
            "required": true,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.283Z",
            "updated-at": "2022-08-31T17:26:25.283Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "64",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "phone",
            "name": "phone",
            "description": "Phone",
            "required": true,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.298Z",
            "updated-at": "2022-08-31T17:26:25.298Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "66",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_select",
            "name": "MilitaryStatus",
            "description": "Military Status",
            "required": false,
            "options": [
              {
                "text": "Non-Military",
                "value": "Non-Military"
              },
              {
                "text": "Active",
                "value": "Active"
              },
              {
                "text": "Discharged",
                "value": "Discharged"
              },
              {
                "text": "Military Spouse",
                "value": "Military Spouse"
              },
              {
                "text": "Military Dependent",
                "value": "Military Dependent"
              }
            ],
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.326Z",
            "updated-at": "2022-08-31T17:26:25.326Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "69",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "submissionPage",
            "description": "Submission Page",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.387Z",
            "updated-at": "2022-08-31T17:26:25.387Z",
            "private": true,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "57",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "first_name",
            "name": "firstName",
            "description": "First Name",
            "required": true,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.208Z",
            "updated-at": "2025-02-03T18:33:17.863Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "70",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "landingPage",
            "description": "Landing Page",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.404Z",
            "updated-at": "2022-08-31T17:26:25.404Z",
            "private": true,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "73",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "testTrackingId",
            "description": "Test Tracking",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-09-29T20:46:38.165Z",
            "updated-at": "2022-09-29T20:46:38.165Z",
            "private": true,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "74",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "gclid",
            "description": "Gclid",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-09-29T20:46:38.180Z",
            "updated-at": "2022-09-29T20:46:38.180Z",
            "private": true,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "61",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "state",
            "name": "contactState",
            "description": "Contact State",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.252Z",
            "updated-at": "2022-09-30T13:19:06.346Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "72",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "Age",
            "description": "Age",
            "required": true,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-09-27T19:37:56.538Z",
            "updated-at": "2022-10-01T16:15:13.763Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "71",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_select",
            "name": "educationLevel",
            "description": "Highest education level completed",
            "required": true,
            "options": [
              {
                "text": "Still in High School",
                "value": "Still in High School"
              },
              {
                "text": "No High School Diploma or GED",
                "value": "No High School Diploma or GED"
              },
              {
                "text": "High School/GED",
                "value": "High School/GED"
              },
              {
                "text": "Certificate/Diploma",
                "value": "Certificate/Diploma"
              },
              {
                "text": "Some College",
                "value": "Some College"
              },
              {
                "text": "Associates Degree",
                "value": "Associates Degree"
              },
              {
                "text": "Bachelors Degree",
                "value": "Bachelors Degree"
              },
              {
                "text": "Masters",
                "value": "Masters"
              },
              {
                "text": "Doctorate",
                "value": "Doctorate"
              }
            ],
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-09-27T19:37:56.532Z",
            "updated-at": "2022-10-01T16:17:29.457Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "65",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_select",
            "name": "contactCountry",
            "description": "Contact Country",
            "required": true,
            "options": [
              {
                "text": "US",
                "value": "US"
              }
            ],
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.312Z",
            "updated-at": "2022-12-05T16:06:45.605Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "59",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "street_address",
            "name": "contactStreet",
            "description": "Contact Street",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-08-31T17:26:25.227Z",
            "updated-at": "2025-01-17T21:25:04.327Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "1844",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "jornaya_leadid_token",
            "description": "Hidden field for the Jornaya LeadID value",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2022-10-31T16:44:11.699Z",
            "updated-at": "2022-10-31T16:44:11.699Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "2527",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_select",
            "name": "StartTimeFrame",
            "description": "When do you plan on starting?",
            "required": false,
            "options": [
              {
                "text": "Immediately",
                "value": "Immediately"
              },
              {
                "text": "1-3 months",
                "value": "1-3 months"
              },
              {
                "text": "4-6 months",
                "value": "4-6 months"
              },
              {
                "text": "6-12 months",
                "value": "6-12 months"
              },
              {
                "text": "Over 1 year",
                "value": "Over 1 year"
              }
            ],
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2023-01-11T19:38:25.262Z",
            "updated-at": "2023-01-11T19:38:40.654Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "2651",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "vuid",
            "description": "vendor lead id",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2024-03-26T17:18:38.524Z",
            "updated-at": "2024-03-26T17:24:28.017Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "2697",
          "type": "fields",
          "attributes": {
            "client-id": 197,
            "field-type": "custom_text",
            "name": "xxTrustedFormCertUrl",
            "description": "Certificate URL value generated from TrustedForm script",
            "required": false,
            "options": null,
            "dependent-on-field-id": null,
            "dependent-on-values": null,
            "created-at": "2024-05-21T14:36:07.361Z",
            "updated-at": "2024-06-04T18:49:51.023Z",
            "private": false,
            "groupable": true,
            "aggregate": null,
            "mutable": false,
            "show-changes": false
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            }
          }
        },
        {
          "id": "629",
          "type": "client-campaigns",
          "attributes": {
            "public-id": "947d6fad",
            "name": "AdHere - Social - Main Programs",
            "campaign-type": "exclusive",
            "status": "active",
            "created-at": "2022-11-21T13:58:29.847Z",
            "custom-attributes": {
              "carrus_source_id": "aff|adhere_SOCIAL"
            },
            "smart-score": null,
            "smart-score-explanation": null
          },
          "relationships": {
            "contract": {
              "data": {
                "id": "88",
                "type": "contracts"
              }
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "558",
          "type": "client-campaigns",
          "attributes": {
            "public-id": "33e75d72",
            "name": "AdHere - Main Programs",
            "campaign-type": "shared",
            "status": "active",
            "created-at": "2022-08-31T17:26:36.479Z",
            "custom-attributes": {
              "carrus_source_id": "aff|adhere_MAIN"
            },
            "smart-score": null,
            "smart-score-explanation": null
          },
          "relationships": {
            "contract": {
              "data": {
                "id": "88",
                "type": "contracts"
              }
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "1050",
          "type": "client-campaigns",
          "attributes": {
            "public-id": "10038d79",
            "name": "I'm new!",
            "campaign-type": "exclusive",
            "status": "active",
            "created-at": "2025-01-17T20:33:11.949Z",
            "custom-attributes": {},
            "smart-score": null,
            "smart-score-explanation": null
          },
          "relationships": {
            "contract": {
              "data": {
                "id": "88",
                "type": "contracts"
              }
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "662",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Advanced Inpatient Coding",
            "created-at": "2022-08-31T17:26:35.498Z",
            "updated-at": "2023-04-25T20:28:54.293Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "AIC",
            "uuid": "dbac70b1-5917-4c0a-9923-ec742a73d6bb",
            "public-id": "1cefdfd8",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": [
                {
                  "id": "9892",
                  "type": "exclusion-rules"
                }
              ]
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "661",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Advanced Outpatient Coding",
            "created-at": "2022-08-31T17:26:35.484Z",
            "updated-at": "2023-04-25T20:28:54.286Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "AOC",
            "uuid": "0ce018e3-7fa7-489a-b627-1cb3a2f436a1",
            "public-id": "0a89b4cd",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "664",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Behavioral & Psychiatric Technician",
            "created-at": "2022-08-31T17:26:35.521Z",
            "updated-at": "2023-04-25T20:28:54.300Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "BHPTC",
            "uuid": "9ae3f37b-78d6-4d2e-ad7d-0613fba6b425",
            "public-id": "1552b601",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "665",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Business Management and Organizational Leadership for Healthcare - Archived",
            "created-at": "2022-08-31T17:26:35.532Z",
            "updated-at": "2023-03-23T15:18:51.118Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "BMOL",
            "uuid": "780268bf-9afa-4cd0-8f01-ae0e4b9fbfa3",
            "public-id": "9de4e10f",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "666",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Business Management and Organizational Leadership for PMP - Archived",
            "created-at": "2022-08-31T17:26:35.544Z",
            "updated-at": "2023-03-23T15:18:51.121Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "BMOL-PMP",
            "uuid": "57a6273a-46c9-433d-b130-e38287a547da",
            "public-id": "2a6b343a",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "671",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CCNA Routing and Switching",
            "created-at": "2022-08-31T17:26:35.611Z",
            "updated-at": "2023-04-25T20:28:54.330Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ROUT",
            "uuid": "97bca140-325c-48db-82d4-4b11fd0d6ab5",
            "public-id": "956751f5",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": [
                {
                  "id": "9893",
                  "type": "exclusion-rules"
                },
                {
                  "id": "9894",
                  "type": "exclusion-rules"
                }
              ]
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "652",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CPC Practice Exam 1",
            "created-at": "2022-08-31T17:26:35.373Z",
            "updated-at": "2023-04-25T20:28:54.264Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CPC-PE1",
            "uuid": "0f702976-73fa-435d-9d0d-0bba36b97409",
            "public-id": "c47e0bde",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "653",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CPC Practice Exam 150",
            "created-at": "2022-08-31T17:26:35.386Z",
            "updated-at": "2023-04-25T20:28:54.272Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CPC-PE150",
            "uuid": "05df47aa-99d0-471b-96f9-b75bbc900fe2",
            "public-id": "12845653",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "651",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CPC Practice Exams",
            "created-at": "2022-08-31T17:26:35.357Z",
            "updated-at": "2023-04-25T20:28:54.255Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CPC-PE",
            "uuid": "43b4e56a-86d0-4dd5-b093-6e84dcb4a329",
            "public-id": "bf672ef9",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "646",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CPT Refresher",
            "created-at": "2022-08-31T17:26:35.274Z",
            "updated-at": "2023-04-25T20:28:54.239Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CPT-RF",
            "uuid": "c0857395-8f8b-4cdb-ab64-f800d8b66af2",
            "public-id": "ddb58a04",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "667",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Cardiology Coding",
            "created-at": "2022-08-31T17:26:35.557Z",
            "updated-at": "2023-04-25T20:28:54.308Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CC",
            "uuid": "e0da6fd4-3821-4340-b5aa-1d97cdf44573",
            "public-id": "78f5e7ab",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "668",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Career Readiness",
            "created-at": "2022-08-31T17:26:35.570Z",
            "updated-at": "2023-04-25T20:28:54.315Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CAREERR",
            "uuid": "359e6552-73aa-4242-bb24-10850ece6f6e",
            "public-id": "44e84dfb",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "669",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Career Success in Healthcare",
            "created-at": "2022-08-31T17:26:35.582Z",
            "updated-at": "2023-04-25T20:28:54.322Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CAREERS",
            "uuid": "1b3b6be2-1534-4c9d-8792-b2f514682972",
            "public-id": "3f35a605",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "670",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Caregiver - Archived",
            "created-at": "2022-08-31T17:26:35.596Z",
            "updated-at": "2023-03-23T15:18:51.126Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CAREG",
            "uuid": "4f75bd8d-e2bc-477d-890e-0b42ee0abd1d",
            "public-id": "a11ce571",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "672",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Certified Healthcare Documentation Specialist",
            "created-at": "2022-08-31T17:26:35.626Z",
            "updated-at": "2023-04-25T20:28:54.338Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CHDS",
            "uuid": "c7f7e7d6-b55b-4e0d-81d1-b7239ad7c1ee",
            "public-id": "49cd2f0a",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "649",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Certified Nursing Assistant - Florida",
            "created-at": "2022-08-31T17:26:35.331Z",
            "updated-at": "2023-04-25T20:28:54.223Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CNA",
            "uuid": "80eefaf5-d98f-45d6-9e77-7f7c1b0de292",
            "public-id": "a5b02317",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": [
                {
                  "id": "1474",
                  "type": "exclusion-rules"
                }
              ]
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "673",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Child Care Administration - Archived",
            "created-at": "2022-08-31T17:26:35.641Z",
            "updated-at": "2023-06-23T15:06:59.268Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CCA",
            "uuid": "f39e4b16-b379-4913-930e-e6231d5b844c",
            "public-id": "0b76318c",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "674",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Clinical Documentation Improvement - Inpatient 2022 - Archived",
            "created-at": "2022-08-31T17:26:35.654Z",
            "updated-at": "2023-06-23T15:07:13.082Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CDI-I",
            "uuid": "2b4acfe8-6a92-41a4-93bf-d0571042536d",
            "public-id": "365f9c96",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "675",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Clinical Documentation Improvement - Outpatient 2022 - Archived",
            "created-at": "2022-08-31T17:26:35.684Z",
            "updated-at": "2023-06-23T15:07:21.225Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CDI-O",
            "uuid": "837635df-0db3-4fd3-ab34-4785605b3e5d",
            "public-id": "8d1e63ae",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "676",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CompTIA Certification Pro: A+, Network+, Security+",
            "created-at": "2022-08-31T17:26:35.699Z",
            "updated-at": "2023-11-27T14:19:39.094Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CompTIA Pro",
            "uuid": "db048280-5bba-4842-a812-79196ada2b4f",
            "public-id": "78c7fded",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "677",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CompTIA Network+",
            "created-at": "2022-08-31T17:26:35.713Z",
            "updated-at": "2023-04-25T20:28:54.376Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "NTK+",
            "uuid": "e0fa268d-4fbd-41f0-854c-6d0bad8bd699",
            "public-id": "2b2743cb",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "679",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CompTIA Project+ - Archived",
            "created-at": "2022-08-31T17:26:35.743Z",
            "updated-at": "2023-03-23T15:18:51.112Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PRJCT+",
            "uuid": "41e913a0-1ba8-4c70-9e5c-eaf3c9be96a8",
            "public-id": "887cb1dd",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "678",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "CompTIA Security+",
            "created-at": "2022-08-31T17:26:35.729Z",
            "updated-at": "2023-04-25T20:28:54.383Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "SEC+",
            "uuid": "7b25fdbe-ad52-49e7-9b55-a7a1a9f478f6",
            "public-id": "2e3d83ad",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "680",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Computer Technician A+",
            "created-at": "2022-08-31T17:26:35.756Z",
            "updated-at": "2022-08-31T17:26:35.756Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CT",
            "uuid": "bc2bcfc8-07ce-4d2d-9650-8e8705b06895",
            "public-id": "0816d900",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "681",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Critical Care and Trauma Coding",
            "created-at": "2022-08-31T17:26:35.770Z",
            "updated-at": "2023-04-25T20:28:54.397Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "CCTC",
            "uuid": "22e51bbb-3362-4b4d-9a88-8ab7c16b470b",
            "public-id": "bdaf46a1",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "647",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "DRG Refresher",
            "created-at": "2022-08-31T17:26:35.287Z",
            "updated-at": "2023-04-25T20:28:54.247Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "DRG-RF",
            "uuid": "3eb49304-9f73-4482-be37-9351daf5e273",
            "public-id": "852773e6",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "654",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Dental Assistant Entry Level",
            "created-at": "2022-08-31T17:26:35.399Z",
            "updated-at": "2022-09-14T16:15:55.666Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "DA",
            "uuid": "f430dbf7-7205-4566-ae14-8c62a823e601",
            "public-id": "4eac45ee",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "682",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "E/M Coding Foundations",
            "created-at": "2022-08-31T17:26:35.785Z",
            "updated-at": "2023-04-25T20:28:54.406Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "E/M",
            "uuid": "e38f1f6f-e37e-48bf-a63e-a3f3939e7ec3",
            "public-id": "5bf13442",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "655",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "EKG Technician",
            "created-at": "2022-08-31T17:26:35.412Z",
            "updated-at": "2022-09-14T16:15:56.548Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "EKG",
            "uuid": "738783de-5a4f-4bd7-b8fd-3730d79b31c9",
            "public-id": "a9a964b9",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "683",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Ethical Hacker Pro",
            "created-at": "2022-08-31T17:26:35.799Z",
            "updated-at": "2023-04-25T20:28:54.413Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HCKR",
            "uuid": "19e7bff9-2854-49c1-94a5-e171c70ea8eb",
            "public-id": "eb5450c3",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "684",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Executive Assistant - Archived",
            "created-at": "2022-08-31T17:26:35.813Z",
            "updated-at": "2023-06-23T15:07:31.614Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "EA",
            "uuid": "9a05d5ad-4366-4e0a-8730-54a01b0c2991",
            "public-id": "bc1302d6",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "685",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Fitness and Wellness Coach - Archived",
            "created-at": "2022-08-31T17:26:35.826Z",
            "updated-at": "2023-06-23T15:07:41.063Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "FWC",
            "uuid": "6398c364-f55d-45ad-bb87-aa64f76df254",
            "public-id": "0971aa5a",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "650",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Fundamentals of HIPAA",
            "created-at": "2022-08-31T17:26:35.344Z",
            "updated-at": "2023-04-25T20:28:54.231Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HIPAA",
            "uuid": "287c778e-d5dd-4327-b845-fa052cd7752e",
            "public-id": "3069179b",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "686",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "HCC/Risk Adjustment",
            "created-at": "2022-08-31T17:26:35.837Z",
            "updated-at": "2023-04-25T20:28:54.390Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HCC-RA",
            "uuid": "c24375ab-55bc-465c-a2af-d67abefb7683",
            "public-id": "18c11519",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "687",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Health & Lifestyle Coach - Archived",
            "created-at": "2022-08-31T17:26:35.849Z",
            "updated-at": "2023-03-23T15:18:51.129Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HLC",
            "uuid": "e52b3952-24d7-4a84-9c85-1990139b81f3",
            "public-id": "177a4930",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "742",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Health Coach",
            "created-at": "2022-10-06T15:43:02.700Z",
            "updated-at": "2023-04-25T20:28:54.657Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HEALTH",
            "uuid": "12b6b81e-7380-4798-9847-fd374bb812d2",
            "public-id": "a47b55ef",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "688",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Healthcare Compliance",
            "created-at": "2022-08-31T17:26:35.861Z",
            "updated-at": "2023-04-25T20:28:54.420Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HCOMP",
            "uuid": "2c7755d5-fa43-48ca-ab91-7692f0b59a1d",
            "public-id": "261cf381",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "689",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Healthcare IT Professional",
            "created-at": "2022-08-31T17:26:35.875Z",
            "updated-at": "2022-08-31T17:26:35.875Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HIT",
            "uuid": "cb8e5568-ef70-4e2d-883e-4aa239d3b044",
            "public-id": "724e2e02",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "690",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Healthcare Management",
            "created-at": "2022-08-31T17:26:35.888Z",
            "updated-at": "2023-04-25T20:28:54.428Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HEALTHM",
            "uuid": "10db746b-dbb1-41f0-a214-b7d945be992d",
            "public-id": "fda7f3c6",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "691",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Help Desk Technician - Archived",
            "created-at": "2022-08-31T17:26:35.901Z",
            "updated-at": "2023-06-23T15:07:51.382Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HELP",
            "uuid": "627fbb5f-f73c-4a1a-b974-b7140f402f5f",
            "public-id": "5a72dba1",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "741",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Help Me Decide",
            "created-at": "2022-10-06T15:43:02.681Z",
            "updated-at": "2023-04-25T20:28:54.649Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HMD",
            "uuid": "8549a23d-3b40-4983-a224-3cbe42bb7e6a",
            "public-id": "f6d7d2a3",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "656",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Hemodialysis Technician",
            "created-at": "2022-08-31T17:26:35.424Z",
            "updated-at": "2022-09-14T16:16:01.020Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HEMO",
            "uuid": "1318e21a-8241-4a27-bbb5-2c4d245fe350",
            "public-id": "d8e4d73e",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": [
                {
                  "id": "1473",
                  "type": "exclusion-rules"
                }
              ]
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "692",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Home Health Aide - Archived",
            "created-at": "2022-08-31T17:26:35.913Z",
            "updated-at": "2023-03-23T15:18:51.133Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "HHA",
            "uuid": "94ec7a46-067d-46f1-9c03-a02ebed864bc",
            "public-id": "87dcef8e",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "693",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "ICD-10-CM Refresher",
            "created-at": "2022-08-31T17:26:35.924Z",
            "updated-at": "2023-04-25T20:28:54.448Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ICD-10-CM-RF",
            "uuid": "1efdad86-159f-4162-a820-7b93b2c66e91",
            "public-id": "7c3ea699",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "694",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "ICD-10-PCS Refresher",
            "created-at": "2022-08-31T17:26:35.935Z",
            "updated-at": "2023-04-25T20:28:54.456Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ICD-10-PCS-RF",
            "uuid": "60ca714d-0b4f-4ffd-abf9-f55b352ab680",
            "public-id": "4d956632",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "699",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "IT Fundamentals Pro",
            "created-at": "2022-08-31T17:26:35.997Z",
            "updated-at": "2023-04-25T20:28:54.496Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ITFP",
            "uuid": "33c90f34-153f-4d50-9ce8-c0fb8821e7e2",
            "public-id": "45964d30",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "695",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Immunization and Vaccination Training | Course",
            "created-at": "2022-08-31T17:26:35.947Z",
            "updated-at": "2023-04-25T20:28:54.465Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "VAX",
            "uuid": "a351e8fb-88b7-4b0c-8403-d2a6274de307",
            "public-id": "d873eb7b",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "696",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Interventional Radiology Coding",
            "created-at": "2022-08-31T17:26:35.959Z",
            "updated-at": "2023-04-25T20:28:54.473Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "IRC",
            "uuid": "360537d3-9d94-4eea-996d-b6bc5b219443",
            "public-id": "8652fac6",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "698",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Introduction to Auditing Inpatient",
            "created-at": "2022-08-31T17:26:35.983Z",
            "updated-at": "2023-04-25T20:28:54.488Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "IAI",
            "uuid": "a2f77ffe-6882-4cc9-b8d7-d5b605005c2b",
            "public-id": "cf352990",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "697",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Introduction to Auditing Outpatient",
            "created-at": "2022-08-31T17:26:35.971Z",
            "updated-at": "2023-04-25T20:28:54.481Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "IAO",
            "uuid": "a1388896-a26c-4b55-af9a-6210cfb314f4",
            "public-id": "31b63157",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "700",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Linux Pro",
            "created-at": "2022-08-31T17:26:36.009Z",
            "updated-at": "2023-04-25T20:28:54.503Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "LNX",
            "uuid": "e4d7add5-06aa-46b6-9c7b-647b5cb07e18",
            "public-id": "c7b1f350",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "701",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Administrative Assistant (MAA)",
            "created-at": "2022-08-31T17:26:36.020Z",
            "updated-at": "2022-08-31T17:26:36.020Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MAA",
            "uuid": "caa965ed-4501-4456-954c-803f575b86cf",
            "public-id": "0d9b0542",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "657",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Assistant",
            "created-at": "2022-08-31T17:26:35.435Z",
            "updated-at": "2022-09-14T16:16:02.102Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MA",
            "uuid": "ca08de7e-01b2-4b99-96a9-34b40d8977bc",
            "public-id": "a12166f7",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": [
                {
                  "id": "1471",
                  "type": "exclusion-rules"
                },
                {
                  "id": "9895",
                  "type": "exclusion-rules"
                }
              ]
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "702",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Billing 2022",
            "created-at": "2022-08-31T17:26:36.032Z",
            "updated-at": "2022-08-31T17:26:36.032Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MB",
            "uuid": "3e0369ef-779d-4b24-ba08-534594ec7c27",
            "public-id": "850f7b22",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "744",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Coding & Billing Professional",
            "created-at": "2022-10-06T15:43:02.742Z",
            "updated-at": "2023-06-26T13:00:59.396Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MCBP",
            "uuid": "d5f6358d-cdce-46f0-a117-378d2ee567b6",
            "public-id": "a28b03f7",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "703",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Coding and Billing for Outpatient Services 2022 - Archived",
            "created-at": "2022-08-31T17:26:36.044Z",
            "updated-at": "2023-06-05T18:58:58.208Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MCOS",
            "uuid": "081c9dc5-89b0-4876-a8df-e7767a57fec7",
            "public-id": "9241aee7",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "704",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Coding for Inpatient Services 2022 - Archived",
            "created-at": "2022-08-31T17:26:36.056Z",
            "updated-at": "2023-06-23T15:08:04.303Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MCIS",
            "uuid": "bd1e366e-0d3a-4a6d-a84f-4b47044d490c",
            "public-id": "ecd7b68b",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "705",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Coding for Outpatient and Inpatient Services 2022 - Archived",
            "created-at": "2022-08-31T17:26:36.068Z",
            "updated-at": "2023-06-05T18:59:11.495Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MCOIS",
            "uuid": "8ce1764d-e105-4897-89b6-7db1a7525ff5",
            "public-id": "4455cbc2",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "658",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Laboratory Assistant",
            "created-at": "2022-08-31T17:26:35.448Z",
            "updated-at": "2023-04-25T20:28:54.279Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MLA",
            "uuid": "ef9eed00-f18a-4ca9-8a82-816432be8c63",
            "public-id": "7d1ed9ef",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "706",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Office Manager 2022",
            "created-at": "2022-08-31T17:26:36.079Z",
            "updated-at": "2023-04-25T20:28:54.511Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MOM",
            "uuid": "58f222a0-fa69-46e6-9112-ceea532b5738",
            "public-id": "c2b20389",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "707",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Records Specialist",
            "created-at": "2022-08-31T17:26:36.091Z",
            "updated-at": "2023-04-25T20:28:54.519Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MRS",
            "uuid": "c44662a8-6c1d-49b8-961d-377c4765b93d",
            "public-id": "f213a471",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "708",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Scribe",
            "created-at": "2022-08-31T17:26:36.104Z",
            "updated-at": "2022-08-31T17:26:36.104Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "SCRIBE",
            "uuid": "0784a00f-b9d5-490a-8d92-f98b6bb8fd89",
            "public-id": "76dd2cdb",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "709",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Medical Transcription and Editing",
            "created-at": "2022-08-31T17:26:36.117Z",
            "updated-at": "2022-08-31T17:26:36.117Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MTE",
            "uuid": "f0d0d4b9-0e99-48b7-8ff6-828ccdfe8ec3",
            "public-id": "f2d028b2",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "710",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Mental Health Technician",
            "created-at": "2022-08-31T17:26:36.130Z",
            "updated-at": "2023-04-25T20:28:54.527Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MHTC",
            "uuid": "9a9572dd-2542-48e2-b7c3-5bc2326a5db8",
            "public-id": "edfd1a00",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "712",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Microsoft 365",
            "created-at": "2022-08-31T17:26:36.155Z",
            "updated-at": "2023-04-25T20:28:54.542Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MICRO-365",
            "uuid": "22f6710a-b86d-4087-9909-8e0984166b7a",
            "public-id": "da5f0aa3",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "711",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Microsoft Office 2019: Specialist - Archived",
            "created-at": "2022-08-31T17:26:36.143Z",
            "updated-at": "2023-06-23T15:08:14.414Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "MOS",
            "uuid": "3f193773-4ac4-4846-acd1-ae2066649312",
            "public-id": "969ca794",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "743",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Military",
            "created-at": "2022-10-06T15:43:02.720Z",
            "updated-at": "2023-04-25T20:28:54.665Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "Military",
            "uuid": "f9708eed-76c7-4ed3-96ed-d82a7c4d92e9",
            "public-id": "463e62fa",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "713",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Neurosurgery Coding",
            "created-at": "2022-08-31T17:26:36.167Z",
            "updated-at": "2023-04-25T20:28:54.549Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "NEUROC",
            "uuid": "ca564653-dad5-492d-8868-a73299114445",
            "public-id": "3b41b54b",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "714",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Nutrition and Personal Trainer",
            "created-at": "2022-08-31T17:26:36.181Z",
            "updated-at": "2022-08-31T17:26:36.181Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "NPT",
            "uuid": "f4ba2a52-13da-4670-af13-9de729012a09",
            "public-id": "0f8e209e",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "715",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Nutritional Coach - Archived",
            "created-at": "2022-08-31T17:26:36.193Z",
            "updated-at": "2023-03-23T15:18:51.136Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "NTRNC",
            "uuid": "f85a8f5d-ab3e-4281-99c3-9b832f8aad5f",
            "public-id": "1f4c751e",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "716",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "OB/GYN Coding",
            "created-at": "2022-08-31T17:26:36.207Z",
            "updated-at": "2023-04-25T20:28:54.557Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "OBGYN",
            "uuid": "f6115323-9e83-40c2-9307-f37dcd1799b4",
            "public-id": "0bd6b454",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "717",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Oncology/Hematology Coding",
            "created-at": "2022-08-31T17:26:36.223Z",
            "updated-at": "2023-04-25T20:28:54.564Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ONC",
            "uuid": "30ee06e8-98e9-4761-a59c-4748506e60ec",
            "public-id": "5fde30cc",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "718",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Orthopedics Coding",
            "created-at": "2022-08-31T17:26:36.235Z",
            "updated-at": "2023-04-25T20:28:54.572Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ORTHOC",
            "uuid": "afdbbea4-14e4-4512-8076-cbf0ffdb0c75",
            "public-id": "a454f24c",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "719",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Patient Care Coordinator - Archived",
            "created-at": "2022-08-31T17:26:36.246Z",
            "updated-at": "2023-03-23T15:18:51.140Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PCC",
            "uuid": "0897f6a8-16fd-4a78-9d99-744820ebce99",
            "public-id": "9e82c140",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "1398",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Patient Care Technician",
            "created-at": "2025-01-17T20:36:22.575Z",
            "updated-at": "2025-01-17T20:36:22.575Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "NEW",
            "uuid": "587e8f8c-4655-4ab4-b3e2-361adeeb96d2",
            "public-id": "18f8aa6f",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "659",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Patient Care Technician",
            "created-at": "2022-08-31T17:26:35.461Z",
            "updated-at": "2022-09-14T16:16:03.510Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PCT",
            "uuid": "751d88be-81ff-4e09-be3d-05aef92325ef",
            "public-id": "6872e95a",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "720",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Peer Support Specialist - Archived",
            "created-at": "2022-08-31T17:26:36.258Z",
            "updated-at": "2023-06-23T15:08:24.052Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PEERSS",
            "uuid": "e412bad9-667f-4e1a-ac28-13d14548ff01",
            "public-id": "8d087b9f",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "660",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Pharmacy Technician",
            "created-at": "2022-08-31T17:26:35.473Z",
            "updated-at": "2022-09-14T16:16:04.018Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PT",
            "uuid": "c2fad8e0-a582-4e75-919d-039ce9c082d1",
            "public-id": "328cb60e",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": [
                {
                  "id": "9897",
                  "type": "exclusion-rules"
                },
                {
                  "id": "9896",
                  "type": "exclusion-rules"
                },
                {
                  "id": "9898",
                  "type": "exclusion-rules"
                },
                {
                  "id": "9898-b",
                  "type": "exclusion-rules"
                },
                {
                  "id": "9899",
                  "type": "exclusion-rules"
                }
              ]
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "648",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Phlebotomy Technician",
            "created-at": "2022-08-31T17:26:35.317Z",
            "updated-at": "2022-09-14T16:16:04.438Z",
            "campus-explorer-program-id": null,
            "program-group-id": 244,
            "program-code": "PHLEB",
            "uuid": "906823ea-ff45-43f0-b6d3-44953b3438d5",
            "public-id": "8c3978da",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "244",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "721",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Physical Therapy Aide",
            "created-at": "2022-08-31T17:26:36.270Z",
            "updated-at": "2022-08-31T17:26:36.270Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PTA",
            "uuid": "fa454d87-cb38-4c8c-9779-b18ba2ef19ef",
            "public-id": "0d0ef818",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "722",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Physical Therapy Office Professional - Archived",
            "created-at": "2022-08-31T17:26:36.284Z",
            "updated-at": "2023-03-23T15:18:51.143Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PTOP",
            "uuid": "73e6a9e7-4014-40d4-92fb-144124b017c0",
            "public-id": "2731f7d7",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "723",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Physician Coding Specialist 2022 - Archived",
            "created-at": "2022-08-31T17:26:36.297Z",
            "updated-at": "2023-06-23T15:08:33.878Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PHYCS",
            "uuid": "cdceb42e-13ce-45af-a139-999c9b1a5c95",
            "public-id": "00aa6d25",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "745",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Preceptor Training Specialist",
            "created-at": "2022-10-06T15:43:02.766Z",
            "updated-at": "2023-04-25T20:28:54.673Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PTS",
            "uuid": "6d6c1070-c03d-4865-be92-d7bb7ac1eb54",
            "public-id": "9d0ae6d7",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "724",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Problem Solving and Decision Making",
            "created-at": "2022-08-31T17:26:36.310Z",
            "updated-at": "2023-04-25T20:28:54.596Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PSDM",
            "uuid": "9e999072-d1d3-42cd-9888-ff90b90c143b",
            "public-id": "c5bf6ef9",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "725",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Professional Bookkeeping - Archived",
            "created-at": "2022-08-31T17:26:36.329Z",
            "updated-at": "2023-06-23T15:08:41.945Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "PBK",
            "uuid": "dbe1871d-46e8-4922-80b6-f649704f4f08",
            "public-id": "00b88551",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "726",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Release of Information Specialist - Archived",
            "created-at": "2022-08-31T17:26:36.346Z",
            "updated-at": "2023-06-23T15:08:54.085Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "ROIS",
            "uuid": "7c373051-f9cc-4ad3-8085-f8493d4e0dfe",
            "public-id": "e374037f",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "953",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Sterile Processing Technician",
            "created-at": "2023-04-21T18:26:09.217Z",
            "updated-at": "2024-07-15T15:39:48.548Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "SPT",
            "uuid": "9a22028d-397e-4a96-a97c-1cfd5f54f518",
            "public-id": "f5c1a8f4",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "727",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Teamwork and the Workplace",
            "created-at": "2022-08-31T17:26:36.359Z",
            "updated-at": "2023-04-25T20:28:54.619Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "TEAM",
            "uuid": "223045aa-552e-4ef1-8374-49a3955c4327",
            "public-id": "9e6e8919",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "740",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Unknown",
            "created-at": "2022-09-29T20:46:39.269Z",
            "updated-at": "2022-09-29T20:46:39.269Z",
            "campus-explorer-program-id": null,
            "program-group-id": 248,
            "program-code": "UNKNOWN",
            "uuid": "413fbfea-e3c0-4f38-8b18-6bc9b21f3d30",
            "public-id": "06b25adb",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "248",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "728",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Venipuncture Procedures",
            "created-at": "2022-08-31T17:26:36.373Z",
            "updated-at": "2023-04-25T20:28:54.627Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "VENI",
            "uuid": "b935233f-8918-43e4-af47-c8f9eea024f3",
            "public-id": "1728ef5f",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "729",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Veterinary Assistant  (Without Externship)",
            "created-at": "2022-08-31T17:26:36.389Z",
            "updated-at": "2022-09-14T16:16:04.985Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "VA",
            "uuid": "71c610a4-d5a5-45d0-86b6-6ffdfe7310f9",
            "public-id": "c72d85bd",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "active"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "730",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Veterinary Receptionist",
            "created-at": "2022-08-31T17:26:36.404Z",
            "updated-at": "2023-12-12T20:18:27.078Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "VR",
            "uuid": "bd61a8db-c2e3-4647-9921-6a54d7aedb6e",
            "public-id": "0fd7bed6",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "inactive"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "731",
          "type": "degree-programs",
          "attributes": {
            "client-id": 197,
            "name": "Wound Care Coding",
            "created-at": "2022-08-31T17:26:36.418Z",
            "updated-at": "2023-04-25T20:28:54.642Z",
            "campus-explorer-program-id": null,
            "program-group-id": 243,
            "program-code": "WOUND",
            "uuid": "045e9bff-b50e-415b-89b1-b8ef5d5aa4da",
            "public-id": "ab16ef98",
            "custom-attributes": {},
            "lp-continue-url": null,
            "status": "hidden"
          },
          "relationships": {
            "client": {
              "data": {
                "id": "197",
                "type": "clients"
              }
            },
            "exclusion-rules": {
              "data": []
            },
            "program-group": {
              "data": {
                "id": "243",
                "type": "program-groups"
              }
            }
          }
        },
        {
          "id": "9892",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Active",
              "Non-Military",
              "Discharged"
            ],
            "position": 1,
            "updated-at": "2025-01-13T16:38:47.733Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "66",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9893",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "US"
            ],
            "position": 1,
            "updated-at": "2025-01-13T19:07:08.880Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "65",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9894",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "not_in",
            "value": [
              "Still in High School",
              "No High School Diploma or GED"
            ],
            "position": 2,
            "updated-at": "2025-01-13T19:07:08.952Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "71",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "1474",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "not_in",
            "value": [
              "FL"
            ],
            "position": 1,
            "updated-at": "2022-09-14T16:19:29.252Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "61",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "1473",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "CA",
              "WA"
            ],
            "position": 1,
            "updated-at": "2022-09-14T16:19:13.886Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "61",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "1471",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "AZ",
              "WA",
              "ND",
              "SD"
            ],
            "position": 1,
            "updated-at": "2022-09-14T16:18:50.883Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "61",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9895",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "US"
            ],
            "position": 2,
            "updated-at": "2025-01-15T20:21:47.808Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "65",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9897",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Active"
            ],
            "position": 2,
            "updated-at": "2025-01-31T17:46:43.759Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "66",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9896",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "not_in",
            "value": [
              "18",
              "19",
              "20"
            ],
            "position": 1,
            "updated-at": "2025-01-31T21:15:33.253Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "72",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9898",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Roseville"
            ],
            "position": 3,
            "updated-at": "2025-02-03T16:54:06.912Z",
            "day-of-week": "Sunday",
            "start-time-of-day": "2025-01-31T09:00:00.253Z",
            "end-time-of-day": "2025-01-31T17:00:00.253Z",
          },
          "relationships": {
            "field": {
              "data": {
                "id": "60",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9898-b",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Potatoville"
            ],
            "position": 3,
            "updated-at": "2025-02-03T16:54:06.912Z",
            "day-of-week": "Saturday",
            "start-time-of-day": "2025-01-31T09:00:00.253Z",
            "end-time-of-day": "2025-01-31T17:00:00.253Z",
          },
          "relationships": {
            "field": {
              "data": {
                "id": "60",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9899",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "less_than",
            "value": [
              "35"
            ],
            "position": 4,
            "updated-at": "2025-02-03T16:54:06.936Z",
            "day-of-week": "Sunday",
            "start-time-of-day": "2025-01-31T09:00:00.253Z",
            "end-time-of-day": "2025-01-31T17:00:00.253Z",
          },
          "relationships": {
            "field": {
              "data": {
                "id": "72",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "1487",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "less_than",
            "value": [
              "18"
            ],
            "position": 2,
            "updated-at": "2022-09-27T19:41:22.356Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "72",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "1488",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Still in High School"
            ],
            "position": 3,
            "updated-at": "2022-09-27T19:41:29.667Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "71",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "1470",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "MA",
              "NY"
            ],
            "position": 1,
            "updated-at": "2022-09-14T15:42:54.329Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "61",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9891",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Active",
              "Military Dependent",
              "Military Spouse"
            ],
            "position": 4,
            "day-of-week": "Thursday",
            "end-time-of-day": "2025-01-31T15:00:00.253Z",
            "updated-at": "2025-01-10T22:14:44.580Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "66",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9900",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "18",
              "19",
              "20",
              "21"
            ],
            "day-of-week": "Tuesday",
            "start-time-of-day": "2025-01-31T15:00:00.253Z",
            "position": 5,
            "updated-at": "2025-02-03T17:49:50.895Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "72",
                "type": "fields"
              }
            }
          }
        },
        {
          "id": "9901",
          "type": "exclusion-rules",
          "attributes": {
            "operator": "in",
            "value": [
              "Somewhere"
            ],
            "position": 6,
            "day-of-week": "Friday",
            "updated-at": "2025-02-03T17:49:50.914Z"
          },
          "relationships": {
            "field": {
              "data": {
                "id": "60",
                "type": "fields"
              }
            }
          }
        }
      ],
    },
  }
}
